import { Form } from 'react-final-form';
import { useHistory } from 'react-router-dom';

import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import { APPLICATION_PATH } from 'routes/paths';

import { HEADING } from './constants';
import HouseholdForm from './form';
import { HouseholdFormValues } from './form/types';
import { useGetHouseholdQuery } from './graphql/GetHousehold';
import { useUpdateHouseholdMutation } from './graphql/UpdateHousehold';
import buildInitialValues from './utils/buildInitialValues';
import { validate } from './utils/validate';

const Household = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.SurveyHousehold);
  const { data, loading } = useGetHouseholdQuery();
  const initialValues = buildInitialValues(data);
  const [updateHousehold] = useUpdateHouseholdMutation();
  const history = useHistory();

  const onCompleted = () => {
    trackStepCompleted();
    history.push(APPLICATION_PATH);
  };

  const onSubmit = (values: HouseholdFormValues) => {
    updateHousehold({
      variables: {
        input: {
          spouseOrPartner: values.spouseOrPartner,
          childrenOrPlanTo: values.childrenOrPlanTo,
          buyingOrOwningHome: values.buyingOrOwningHome,
          annualIncome: Number(values.annualIncome),
          spouseAnnualIncome: Number(values.spouseAnnualIncome),
          spousalQuotesRequested: values.spousalQuotesRequested,
        },
      },
    });
    onCompleted();
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent heading={HEADING} title={Steps.SurveyHousehold}>
      <Form<HouseholdFormValues, InitialValues<HouseholdFormValues>>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <HouseholdForm {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default Household;
